import React, { AllHTMLAttributes, ComponentClass, PureComponent } from 'react';
import styled from 'styled-components';
import { StyledComponent } from '../types';

interface HtmlComponentState {
  StyledComponent: StyledComponent<any, any>;
}

type HtmlComponentProps = AllHTMLAttributes<HTMLElement> & {
  style?: string;
  class?: string;
};

// TODO: check wether a more typesafe type declaration is possible
export const htmlComponent = (Component: keyof JSX.IntrinsicElements) => {
  class HtmlComponent extends PureComponent<
    HtmlComponentProps,
    HtmlComponentState
  > {
    public state: HtmlComponentState = {
      StyledComponent: styled(Component)`
        ${this.props.style || ''};
      `
    };

    public render() {
      const { style, class: className, ...props } = this.props;
      const { StyledComponent } = this.state;
      return <StyledComponent {...props} className={className} />;
    }
  }

  (HtmlComponent as ComponentClass).displayName = `htmlComponent(${Component})`;

  return HtmlComponent;
};
